// extracted by mini-css-extract-plugin
module.exports = {"ResetFilter":"resetFilter_ResetFilter__IijRy","title":"resetFilter_title__8hhyL","txt":"resetFilter_txt__tbUav","confirm":"resetFilter_confirm__X2wpR"};